<div class="g-just-flex" style="width: 100%; height:100vh">
    <div class="g-just-flex flex-column gap-15 noresult">
        <div class="title">
            No report yet for this lab request.
        </div>
        <button mat-raised-button (click)="addReport()" style="border-radius: 3px;">
            <mat-icon>add</mat-icon>
            Add A Report</button>
    </div>
</div>